import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PersonalInfoSection = ({ profile, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    fullName: profile?.name,
    email: profile?.email,
    phone: profile?.phone,
    dateOfBirth: profile?.dateOfBirth,
    gender: profile?.gender,
    address: profile?.address,
    city: profile?.city,
    state: profile?.state,
    zipCode: profile?.zipCode,
    emergencyContact: profile?.emergencyContact,
    emergencyPhone: profile?.emergencyPhone
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
  };

  const handleSave = () => {
    onSave(formData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      fullName: profile?.name,
      email: profile?.email,
      phone: profile?.phone,
      dateOfBirth: profile?.dateOfBirth,
      gender: profile?.gender,
      address: profile?.address,
      city: profile?.city,
      state: profile?.state,
      zipCode: profile?.zipCode,
      emergencyContact: profile?.emergencyContact,
      emergencyPhone: profile?.emergencyPhone
    });
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg">
            <Icon name="User" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              Personal Information
            </h2>
            <p className="text-sm text-muted-foreground caption">
              Manage your personal details
            </p>
          </div>
        </div>
        {!isEditing && (
          <Button
            variant="outline"
            size="default"
            iconName="Edit"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Full Name"
          type="text"
          name="fullName"
          value={formData?.fullName}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
        <Input
          label="Email Address"
          type="email"
          name="email"
          value={formData?.email}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          value={formData?.phone}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
        <Input
          label="Date of Birth"
          type="date"
          name="dateOfBirth"
          value={formData?.dateOfBirth}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
        <Input
          label="Gender"
          type="text"
          name="gender"
          value={formData?.gender}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <Input
          label="Address"
          type="text"
          name="address"
          value={formData?.address}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <Input
          label="City"
          type="text"
          name="city"
          value={formData?.city}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <Input
          label="State"
          type="text"
          name="state"
          value={formData?.state}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <Input
          label="ZIP Code"
          type="text"
          name="zipCode"
          value={formData?.zipCode}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <Input
          label="Emergency Contact Name"
          type="text"
          name="emergencyContact"
          value={formData?.emergencyContact}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
        <Input
          label="Emergency Contact Phone"
          type="tel"
          name="emergencyPhone"
          value={formData?.emergencyPhone}
          onChange={handleChange}
          disabled={!isEditing}
          required
        />
      </div>
      {isEditing && (
        <div className="flex items-center justify-end gap-3 mt-6 pt-6 border-t border-border">
          <Button
            variant="outline"
            size="default"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Save"
            iconPosition="left"
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </div>
      )}
    </div>
  );
};

export default PersonalInfoSection;